import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title, titleSize, subtitle, subtitleSize }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <Box mb="30px">
            <Typography
                variant={titleSize}
                color={colors.grey[100]}
                fontWeight="bold"
                sx={{ m: "0 0 2px 10px" }}
            >
                {title}
            </Typography>
            <Typography
                variant={subtitleSize}
                color={colors.blueAccent[500]}
                sx={{ m: "0 0 2px 10px" }}
            >
                {subtitle}
            </Typography>
        </Box>
    );
};

export default Header;